import { AxiosError } from 'axios';
import { translate } from './translate';

export const processResponseErrors = (error: unknown) => error instanceof AxiosError && (error.response?.data?.errors || [{ code: '', message: translate({ key: error?.message }) || translate({ key: 'error.common', fallback: 'Undefined Error' }) }]);
